<script>
  export let images = [];
  export let title = "";
  export let description = "";
</script>

<article class="flex flex-col justify-center items-center px-4 py-6 bg-white rounded-3xl border border-solid shadow-2xl border-neutral-200 w-full">
  <figure class="flex justify-center items-center self-center px-2 w-full">
    <img loading="lazy" src={images[0]} alt={title} class="max-w-full max-h-48 object-cover" />
  </figure>

  <h1 class="mt-3 text-3xl tracking-tighter text-zinc-800 text-center">{title}</h1>
  <p class="mt-3 text-sm leading-5 text-center text-neutral-500">{description}</p>
</article>
